import React from 'react';
import { IQuickFilterContext } from 'framework/IQuickFilterContext';
import { ITableViewContext } from 'framework/table/ITableViewContext';
import { DailyReceiptExportProp, IDailyReceipt } from 'gen/ApiClient';
import { QuickFilter } from '../DailyReceiptsList';
import { SelectableColumn } from '../SelectableColumn';

interface IViewContext extends ITableViewContext<SelectableColumn, IDailyReceipt>, IQuickFilterContext<QuickFilter> {
	exportRecord: Record<DailyReceiptExportProp, string>;
}

export const ViewContext = React.createContext<IViewContext>(undefined as any);
